import { render, staticRenderFns } from "./LeadershipCard.vue?vue&type=template&id=fcfa264c&scoped=true&"
import script from "./LeadershipCard.vue?vue&type=script&lang=js&"
export * from "./LeadershipCard.vue?vue&type=script&lang=js&"
import style0 from "./LeadershipCard.vue?vue&type=style&index=0&id=fcfa264c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfa264c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VCard,VCardText,VContainer,VFadeTransition,VHover,VIcon,VImg,VOverlay})
